<template>
  <div>
    <v-list-item>
      <v-list-item-icon class="mr-4">
        <v-icon v-if="deadlineEntry.status === 'notDefined'" color="red"
          >mdi-help</v-icon
        >
        <v-icon v-else-if="deadlineEntry.status === 'valid'" color="green"
          >mdi-check</v-icon
        >
        <v-icon v-else-if="deadlineEntry.status === 'soonDue'" color="orange"
          >mdi-timer-sand</v-icon
        >
        <v-icon v-else-if="deadlineEntry.status === 'expired'" color="red"
          >mdi-close</v-icon
        >
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">{{
          deadlineEntry.deadline.title
        }}</v-list-item-title>
        <v-list-item-subtitle>
          <span
            v-if="!deadlineEntry.dueDate"
            class="red--text font-weight-medium"
          >
            Keine Frist gesetzt
          </span>
          <span v-else-if="deadlineEntry.status === 'valid'">{{
            timestampConverter(deadlineEntry.dueDate)
          }}</span>
          <span
            v-else-if="deadlineEntry.status === 'soonDue'"
            class="orange--text font-weight-medium"
            >Läuft in Kürze ab:
            {{ timestampConverter(deadlineEntry.dueDate) }}</span
          >
          <span
            v-else-if="deadlineEntry.status === 'expired'"
            class="red--text font-weight-medium"
            >Abgelaufen am:
            {{ timestampConverter(deadlineEntry.dueDate) }}</span
          >
          <br />
          <v-chip
            small
            outlined
            v-for="(label, index) in deadlineEntry.labels"
            :key="index"
            class="py-0 mb-0 mt-1 mr-1"
          >
            {{ label }}</v-chip
          >
          {{ note }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action
        v-if="
          !hideActions && deadlineEntry.deadline.updatePolicy !== 'noUpdate'
        "
        class="d-inline"
      >
        <v-btn
          outlined
          text
          class="mx-0 px-0"
          :color="
            deadlineEntry.status == 'expired' ||
            deadlineEntry.status == 'notDefined'
              ? 'red'
              : ''
          "
          style="min-width: 40px !important"
          @click="toggleDeadlineEntryUpdateDialog()"
        >
          <v-icon dense>mdi-timer-edit-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="
            deadlineEntry.deadline.renewalPolicy == 'selfUpdate' &&
            !deadlineEntry.scheduledRenewal
          "
          outlined
          text
          class="ml-2 mx-0 px-0"
          :color="
            deadlineEntry.status == 'expired' ||
            deadlineEntry.status == 'notDefined'
              ? 'red'
              : ''
          "
          style="min-width: 40px !important"
          @click="toggleScheduleRenewalDialog()"
        >
          <v-icon dense>mdi-calendar-plus</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <info-card
      v-if="deadlineEntry.scheduledRenewal"
      title="Verlängerung geplant"
      icon="mdi-calendar"
      :showDetails.sync="showRenewalDetails"
      class="mx-4"
    >
      <template v-slot:details>
        <v-card-text class="py-2">
          <strong>Geplanter Termin:</strong>
          {{
            timestampConverterWithTime(
              deadlineEntry.scheduledRenewal.timestamp,
            )
          }}<br />
          <strong>Ort:</strong>
          {{ deadlineEntry.scheduledRenewal.location }}
          <br />
          {{ deadlineEntry.scheduledRenewal.note }}
        </v-card-text>
        <v-card-actions
          v-if="
            deadlineEntry.scheduledRenewal &&
            deadlineEntry.scheduledRenewal.timestamp &&
            ((deadlineEntry.scheduledRenewal.timestamp.toDate() < new Date() &&
              (deadlineEntry.deadline.updatePolicy === 'selfUpdate' ||
                deadlineEntry.deadline.updatePolicy === 'proposeUpdate')) ||
              (deadlineEntry.scheduledRenewal.timestamp.toDate() > new Date() &&
                deadlineEntry.deadline.renewalPolicy === 'selfUpdate'))
          "
          class="mx-2 pt-0"
        >
          <v-btn
            v-if="
              deadlineEntry.scheduledRenewal.timestamp.toDate() < new Date() &&
              (deadlineEntry.deadline.updatePolicy === 'selfUpdate' ||
                deadlineEntry.deadline.updatePoliy === 'proposeUpdate')
            "
            depressed
            small
            color="primary"
            @click="toggleDeadlineEntryUpdateDialog()"
            ><v-icon left>mdi-timer-edit-outline</v-icon>Ergebnis
            mitteilen</v-btn
          >
          <div
            v-if="
              deadlineEntry.scheduledRenewal.timestamp.toDate() > new Date() &&
              deadlineEntry.deadline.renewalPolicy === 'selfUpdate'
            "
          >
            <v-btn
              depressed
              small
              text
              outlined
              color="primary"
              @click="toggleScheduleRenewalDialog()"
              class="mr-2"
              ><v-icon left>mdi-calendar-edit</v-icon>Termin
              aktualisieren</v-btn
            >
            <v-btn
              depressed
              small
              color="error"
              text
              outlined
              @click="toggleCancelRenewalDialog()"
              ><v-icon left>mdi-calendar-remove</v-icon>Termin absagen
            </v-btn>
          </div>
        </v-card-actions>
      </template>
    </info-card>
    <info-card
      v-if="deadlineEntry.pendingUpdate"
      title="
        Verlängerung wartet auf Genehmigung
      "
      icon="mdi-alert-circle"
      class="mx-4"
    >
      <template v-slot:details>
        <v-card-text class="py-2">
          <strong>Neuer Wert:</strong>
          {{ timestampConverter(deadlineEntry.pendingUpdate.newDueDate) }}<br />
          <v-chip
            small
            outlined
            v-for="(label, index) in deadlineEntry.pendingUpdate.newLabels"
            :key="index"
            class="py-0 mb-0 mt-1 mr-1"
          >
            {{ label }}</v-chip
          >
          {{ deadlineEntry.pendingUpdate.newNote }}
          <br />
          <small class="grey--text text--darken-1">
            Hinzugefügt von
            {{ deadlineEntry.pendingUpdate.lastUpdatedBy.displayName }} am
            {{
              timestampConverterWithTime(
                deadlineEntry.pendingUpdate.lastUpdatedAt,
              )
            }}
            Uhr</small
          >
        </v-card-text>
      </template>
    </info-card>
    <DeadlineEntryUpdateDialog
      v-if="showDeadlineEntryUpdateDialog"
      @close="toggleDeadlineEntryUpdateDialog()"
      :deadlineEntry="deadlineEntry"
      hidden
    ></DeadlineEntryUpdateDialog>
    <DeadlineEntryRenewalDialog
      v-if="showScheduleRenewalDialog"
      @close="toggleScheduleRenewalDialog()"
      :deadlineEntry="deadlineEntry"
      hidden
    ></DeadlineEntryRenewalDialog>
    <DeadlineEntryRenewalCancelDialog
      v-if="showCancelRenewalDialog"
      @close="toggleCancelRenewalDialog()"
      :deadlineEntry="deadlineEntry"
      hidden
    ></DeadlineEntryRenewalCancelDialog>
  </div>
</template>

<script>
import InfoCard from "@/components/_systemwide/InfoCard.vue";
import DeadlineEntryUpdateDialog from "@/components/member-management/deadlines/DeadlineEntryUpdateDialog.vue";
import DeadlineEntryRenewalDialog from "@/components/member-management/deadlines/DeadlineEntryRenewalDialog.vue";
import DeadlineEntryRenewalCancelDialog from "@/components/member-management/deadlines/DeadlineEntryRenewalCancelDialog.vue";
export default {
  name: "deadline-entry-list-item",
  components: {
    InfoCard,
    DeadlineEntryUpdateDialog,
    DeadlineEntryRenewalDialog,
    DeadlineEntryRenewalCancelDialog,
  },
  props: {
    deadlineEntry: {
      type: Object,
      required: true,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showRenewalDetails: false,
      showDeadlineEntryUpdateDialog: false,
      showScheduleRenewalDialog: false,
      showCancelRenewalDialog: false,
    };
  },
  created() {
    if (
      this.deadlineEntry.scheduledRenewal.timestamp &&
      this.deadlineEntry.scheduledRenewal.timestamp.toDate() < new Date()
    ) {
      this.showRenewalDetails = true;
    }
  },
  methods: {
    timestampConverter(timestamp) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    timestampConverterWithTime(timestamp) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    toggleDeadlineEntryUpdateDialog() {
      this.showDeadlineEntryUpdateDialog = !this.showDeadlineEntryUpdateDialog;
    },
    toggleScheduleRenewalDialog() {
      this.showScheduleRenewalDialog = !this.showScheduleRenewalDialog;
    },
    toggleCancelRenewalDialog() {
      this.showCancelRenewalDialog = !this.showCancelRenewalDialog;
    },
  },
};
</script>
